import type { BinderBlindingScope, StudySiteBinderRow } from '@/api/client';

type ScopedBinder = Pick<StudySiteBinderRow, 'blinding_scope'>;

export function binderScope(b: ScopedBinder | null | undefined): BinderBlindingScope {
  return b?.blinding_scope || 'open';
}

export function isPrimaryBinder(b: ScopedBinder): boolean {
  return binderScope(b) !== 'unblinded';
}

export function binderScopeLabel(scope: BinderBlindingScope): string | null {
  if (scope === 'blinded') return 'Blinded';
  if (scope === 'unblinded') return 'Unblinded';
  return null;
}

export function binderScopeSuffix(b: ScopedBinder): string {
  const label = binderScopeLabel(binderScope(b));
  return label ? ` · ${label}` : '';
}

export function sortBindersPrimaryFirst(rows: StudySiteBinderRow[]): StudySiteBinderRow[] {
  const createdAt = (r: StudySiteBinderRow) => new Date(r.created_at).getTime();
  const latestByStudy = new Map<string, number>();
  for (const r of rows) {
    latestByStudy.set(r.study_id, Math.max(latestByStudy.get(r.study_id) ?? 0, createdAt(r)));
  }
  return [...rows].sort(
    (a, b) =>
      (latestByStudy.get(b.study_id) ?? 0) - (latestByStudy.get(a.study_id) ?? 0) ||
      a.study_id.localeCompare(b.study_id) ||
      Number(isPrimaryBinder(b)) - Number(isPrimaryBinder(a)) ||
      createdAt(b) - createdAt(a),
  );
}
